import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import MagneticButton from './MagneticButton';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1508361727343-ca787442dcd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc2ODM0Nzc5NXww&ixlib=rb-4.1.0&q=85)`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 via-slate-900/80 to-slate-900"></div>
      </div>

      {/* Breathing Background Effect */}
      <div className="breathing-bg"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="animate-fade-in-up">
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-cyan-400 via-teal-400 to-emerald-400 bg-clip-text text-transparent">
              Dijital büyümeyi<br />varsayımlarla değil,<br />verilerle inşa ediyoruz
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-10 font-light max-w-4xl mx-auto leading-relaxed">
            Yapay zekâ, kullanıcı davranışı ve veri analitiğini birleştirerek;<br className="hidden md:block" />
            SEO, performans pazarlaması ve kullanıcı deneyimini tek bir büyüme sistemine dönüştürüyoruz.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
            <MagneticButton>
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white px-8 py-6 text-lg group transition-all duration-300 hover:scale-105"
              >
                Mini Analiz İste
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </MagneticButton>
            
            <MagneticButton>
              <Button
                onClick={scrollToAbout}
                size="lg"
                variant="outline"
                className="border-2 border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 px-8 py-6 text-lg backdrop-blur-sm transition-all duration-300"
              >
                Yaklaşımımızı Gör
              </Button>
            </MagneticButton>
          </div>

          <p className="text-sm text-gray-500 font-light">
            Sınırlı sayıda projeyle çalışıyoruz
          </p>
        </div>
      </div>

      {/* Animated Gradient Orbs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-cyan-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
    </section>
  );
};

export default HeroSection;
